import React from "react";
import { useMsal } from "@azure/msal-react";
import "../assets/css/Header.css";
import logo from "../assets/images/NitorLogo.png";

export default function Header() {
  const fullUrl = window.location.href;
  const urlParts = fullUrl.split("/");
  const parentURL = urlParts[urlParts.length - 1] || "";
  const childURL = urlParts[urlParts.length - 2] || "";
  const { instance, accounts } = useMsal();
  const userDepartment = sessionStorage.getItem("user_department");
  const handleLogout = async () => {
    document.body.style.opacity = "0.5";
    await instance.logoutRedirect({ postLogoutRedirectUri: "/" });
    document.body.style.opacity = "1";
  };
  const handleLibrary = async () => {
    document.body.style.opacity = "0.5";

  };
  const handleNotification = async () => {
    document.body.style.opacity = "0.5";

  };

  const isPresales = (parentURL === 'presales' || childURL === 'presales') ? true : false;
  return (
    <header className="main-header shadow-sm py-2">
      <div className="container d-flex align-items-center justify-content-between">
        {/* Left: Logo */}
        <div className="header-left">
          <a target="_blank" rel="noreferrer" href="https://www.nitorinfotech.com/">
            <img src={logo} alt="Nitor Infotech" className="logo-image" />
          </a>
        </div>

        {/* Center: Search Bar */}
        <div className="header-center flex-grow-1 mx-4">
          <div className="search-wrapper">
            <i className="fa fa-search search-icon"></i>
            <input
              type="text"
              className="form-control global-search-input"
              placeholder="Search resources (e.g. case studies, tags, industries)..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  window.location.href = `/?search=${encodeURIComponent(e.target.value)}`;
                }
              }}
              defaultValue={new URLSearchParams(window.location.search).get("search") || ""}
            />
          </div>
        </div>

        {/* Right: User Info + Logout */}
        <div className="header-right">
          {/* {username && (
            <span className="user-email" title={username}>
              {username}
            </span>
          )} */}
          {/* <button onClick={handleLibrary} className="header-btn">
            <i className="fa fa-bookmark"></i>
          </button> */}
          <a href="/my-library" className="header-btn">
            <i className="fa fa-bookmark"></i>
          </a>
          {userDepartment == 'admin' ? (
            <a href="/download-request" className="header-btn">
              <i className="fa fa-bell"></i>
            </a>
          ) : ''}
          <button onClick={handleLogout} className="header-btn">
            <i className="fa fa-sign-out"></i>
          </button>
        </div>
      </div>
    </header>
  );
}
